import { slices } from "@/constants/sliceNames";
import {
  requestOrganizationsStatus,
  requestDeleteOrganizationStatus,
  requestCreateOrganizationStatus,
  requestSingleOrganizationStatus,
  requestEditOrganizationStatus,
  requestOrganizationsStatsStatus,
  requestOrganizationsStatsDatasetStatus,
} from "@/store/effects/admin-dashboard/organizations-effects";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  organization: null,
  loading: false,
  pageLimit: null,
  currentPage: null,
  totalPages: null,
  recordsCount: null,
  error: null,
  statistics: null,
  executionLoading: false,
  datasetLoading: false,
  statistics: {
    datasets: [],
    resources: [],
    userExecs: {},
  },
};

const organizationsSlice = createSlice({
  name: slices.organizations,
  initialState,
  extraReducers: {
    ...requestOrganizationsStatus,
    ...requestDeleteOrganizationStatus,
    ...requestCreateOrganizationStatus,
    ...requestSingleOrganizationStatus,
    ...requestEditOrganizationStatus,
    ...requestOrganizationsStatsStatus,
    ...requestOrganizationsStatsDatasetStatus,
  },
});

const { actions, reducer } = organizationsSlice;

export { actions, initialState };

export default reducer;
